<template>
  <el-dialog
    title="付款通知书"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="0"
    width="800px"
    :modal="false"
    :show-close="false"
    class="paydoc-dia"
  >
    <div slot="title">
      <span>付款通知书模版：</span>
      <el-select v-model="tmpType" size="mini" style="width:130px;margin:0 20px 0 5px" @change="changeTmp">
        <el-option value="normal" label="阿尔法正常模板"></el-option>
        <el-option value="detail" label="财务/人力拆分版"></el-option>
      </el-select>
      <span>收款公司：</span>
      <el-select v-model="bank" size="mini" style="width:220px;margin: 0 55px 0 5px" @change="changeBank">
        <el-option v-for="(b, k) in banks" :key="k" :value="b.账户名称"></el-option>
      </el-select>
      <el-button type="info" plain size="mini" @click="dialogVisible = false">上一步</el-button>
      <el-button v-if="tmpType == 'normal' || isFinance" type="primary" size="mini" @click="confirm"
        >制作完成</el-button
      >
    </div>
    <div v-if="tmpType == 'normal'">
      <div class="text-warn text-12 mgb-10">
        您需要做：<br />
        1、请确认标红输入框的内容<br />
        2、请确认付款金额和费率是否正确<br />
        3、请确认收款主体是否正确
      </div>
      <div style="text-align:center;font-size:18px;font-weight:bold;margin-bottom:20px">付款通知书</div>
      <div>
        <div class="paydoc-dia-form-item">
          <label style="width:75px">公司名：</label>
          <el-input v-model="form.客户公司名称" size="mini" placeholder="客户公司全称" style="width:400px"></el-input>
        </div>
        <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.客户公司地址 }" style="margin-bottom:20px">
          <label style="width:75px">地 址：</label>
          <el-input
            v-model="form.客户公司地址"
            size="mini"
            placeholder="付款HR的收件地址"
            style="width:400px"
          ></el-input>
          <span class="text-warn text-12">（请确定地址是否准确）</span>
        </div>
        <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.对接HR }">
          <label style="width:75px">收件人：</label>
          <div class="pos-cate" style="display:inline-block;width:400px">
            <el-input v-model="form.对接HR" size="mini" placeholder="收件HR姓名" @focus="showHrs"></el-input>
            <div
              v-if="isHrShow"
              class="pos-cate-drop el-select-dropdown el-popper"
              x-placement="bottom-start"
              style="padding:15px 20px"
            >
              <i
                class="el-icon-close"
                style="position:absolute;top:5px;right:5px;cursor:pointer"
                @click="isHrShow = false"
              ></i>
              <div x-arrow="" class="popper__arrow" style="left: 35px;"></div>
              <div style="max-height:300px;overflow:auto">
                <div v-for="(hr, k) in companyHrs" :key="k" class="pos-cate-drop-item">
                  <span class="a-link" @click="chooseHr(hr)">选择</span> &nbsp; <span>{{ hr.姓名 }}</span> &nbsp;
                  <span>{{ hr.目前职位 }}</span>
                </div>
              </div>
              <div style="padding-top:5px">没找到，<span class="a-link" @click="defaultSerchRadish">新建HR</span></div>
            </div>
          </div>
          <div class="text-warn text-12" style="padding-left:70px">
            （点击输入框，从下拉列表中找到收件HR，然后点击选择；如果没有请新建）
          </div>
        </div>
        <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.电话 }">
          <label style="width:75px">电话：</label>
          <el-input v-model="form.电话" size="mini" placeholder="收件HR电话" style="width:400px"></el-input>
        </div>

        <div class="paydoc-dia-form-item" style="margin-bottom:20px">
          <div style="margin-bottom:5px">付款描述：</div>
          <div style="color: #666" v-if="times === 'first1st'">
            感谢对我们的支持与信赖！ <br />
            我们已成功推荐<el-input v-model="form.岗位名称" size="mini" style="width:170px"></el-input>-<el-input
              v-model="form.候选人姓名"
              size="mini"
              style="width:75px"
            ></el-input
            >到贵公司正式入职，根据双方合同约定，猎头服务费为人民币
            <el-input v-model="form.服务费" size="mini" style="width:170px"></el-input> 元 ,请贵公司收到付款通知书及发票
            <el-input v-model="form.工作日" size="mini" style="width:170px"></el-input>
            个工作日内向我司完成支付。支付上述猎头服务费的<el-input
              v-model="form.本期百分比"
              size="mini"
              style="width:170px"
            ></el-input
            >% ，即人民币<el-input v-model="form.本期支付费用" size="mini" style="width:170px"></el-input>元
            ，剩余费用待人选入职满<el-input v-model="form.试用期" size="mini" style="width:170px"></el-input
            >个月后进行支付。<br />
            感恩能与贵公司一路同行！
          </div>
          <div style="color: #666" v-else-if="times === 'second'">
            感谢对我们的支持与信赖！ <br />
            我们已成功推荐<el-input v-model="form.岗位名称" size="mini" style="width:170px"></el-input>-<el-input
              v-model="form.候选人姓名"
              size="mini"
              style="width:75px"
            ></el-input
            >到贵公司入职满<el-input v-model="form.入职期" size="mini" style="width:170px"></el-input>
            个月，根据双方合同约定，贵公司应支付剩余的猎头服务费，即人民币<el-input
              v-model="form.本期支付费用"
              size="mini"
              style="width:170px"
            ></el-input
            >元，,请贵公司收到付款通知书及发票
            <el-input v-model="form.工作日" size="mini" style="width:170px"></el-input>
            个工作日内向我司完成支付。<br />
            感恩能与贵公司一路同行！
          </div>
          <div style="color: #666" v-else>
            感谢对我们的支持与信赖！ <br />
            我们已成功推荐<el-input v-model="form.岗位名称" size="mini" style="width:170px"></el-input>-<el-input
              v-model="form.候选人姓名"
              size="mini"
              style="width:75px"
            ></el-input
            >到贵公司正式入职，根据双方合同约定，猎头服务费为人民币
            <el-input v-model="form.服务费" size="mini" style="width:170px"></el-input> 元 ,请贵公司收到付款通知书及发票
            <el-input v-model="form.工作日" size="mini" style="width:170px"></el-input>
            个工作日内向我司完成支付。<br />
            感恩能与贵公司一路同行！
          </div>
        </div>
        <div class="paydoc-dia-form-item" style="border-top: 1px dotted #ccc;padding-top:10px;margin-top:10px">
          <label style="width:70px">付款信息：</label>
          <span class="text-12 text-warn">（需要注意查看合同签的是哪个主体）</span>
        </div>
        <div class="paydoc-dia-form-item">
          <label style="width:70px">公司名称：</label>
          <el-input v-model="form.公司名称" size="mini" style="width:300px"></el-input>
        </div>
        <div class="paydoc-dia-form-item">
          <label style="width:70px">开户行：</label>
          <el-input v-model="form.银行名称" size="mini" style="width:300px"></el-input>
        </div>
        <div class="paydoc-dia-form-item">
          <label style="width:70px">账 号：</label>
          <el-input v-model="form.银行账号" size="mini" style="width:300px"></el-input>
        </div>
      </div>
    </div>
    <div v-else-if="tmpType == 'detail'" style="position:relative">
      <el-button type="primary" size="mini" style="position:absolute;top:0;right:0" @click="isFinance = !isFinance">
        {{ isFinance ? '切换到人力版' : '切换到财务版' }}
      </el-button>
      <div style="font-size:16px;font-weight:bold;margin-bottom:3px">客户资料：</div>
      <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.客户公司名称 }">
        <label style="width:75px">客户名称：</label>
        <el-input v-model="form.客户公司名称" size="mini" placeholder="客户公司全称" style="width:350px"></el-input>
      </div>
      <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.对接HR }">
        <label style="width:75px">联系人：</label>
        <div class="pos-cate" style="display:inline-block;width:350px">
          <el-input v-model="form.对接HR" size="mini" placeholder="对接HR姓名" @focus="showHrs"></el-input>
          <div
            v-if="isHrShow"
            class="pos-cate-drop el-select-dropdown el-popper"
            x-placement="bottom-start"
            style="padding:15px 20px"
          >
            <i
              class="el-icon-close"
              style="position:absolute;top:5px;right:5px;cursor:pointer"
              @click="isHrShow = false"
            ></i>
            <div x-arrow="" class="popper__arrow" style="left: 35px;"></div>
            <div style="max-height:300px;overflow:auto">
              <div v-for="(hr, k) in companyHrs" :key="k" class="pos-cate-drop-item">
                <span class="a-link" @click="chooseHr(hr)">选择</span> &nbsp; <span>{{ hr.姓名 }}</span> &nbsp;
                <span>{{ hr.目前职位 }}</span>
              </div>
            </div>
            <div style="padding-top:5px">没找到，<span class="a-link" @click="defaultSerchRadish">新建HR</span></div>
          </div>
        </div>
        <div class="text-warn text-12" style="padding-left:70px">
          （点击输入框，从下拉列表中找到收件HR，然后点击选择；如果没有请新建）
        </div>
      </div>
      <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.电话 }">
        <label style="width:75px">电话：</label>
        <el-input v-model="form.电话" size="mini" placeholder="对接HR电话" style="width:350px"></el-input>
      </div>
      <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.邮箱 }">
        <label style="width:75px">电子邮箱：</label>
        <el-input v-model="form.邮箱" size="mini" placeholder="对接HR邮箱" style="width:350px"></el-input>
      </div>
      <div v-if="!isFinance">
        <div style="font-size:16px;font-weight:bold;margin: 10px 0 3px 0">候选人信息：</div>
        <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.候选人姓名 }">
          <label style="width:75px">候选人：</label>
          <el-input v-model="form.候选人姓名" size="mini" placeholder="候选人姓名" style="width:350px"></el-input>
        </div>
        <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.部门 }">
          <label style="width:75px">部门：</label>
          <el-input v-model="form.部门" size="mini" placeholder="部门" style="width:350px"></el-input>
        </div>
        <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.级别 }">
          <label style="width:75px">级别：</label>
          <el-input v-model="form.级别" size="mini" placeholder="级别" style="width:350px"></el-input>
        </div>
        <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.职位 }">
          <label style="width:75px">职位：</label>
          <el-input v-model="form.职位" size="mini" placeholder="职位" style="width:350px"></el-input>
        </div>
        <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.工作地点 }">
          <label style="width:75px">工作地点：</label>
          <el-input v-model="form.工作地点" size="mini" placeholder="工作地点" style="width:350px"></el-input>
        </div>
        <div class="paydoc-dia-form-item" :class="{ 'paydoc-require': !form.入职日期 }">
          <label style="width:75px">入职日期：</label>
          <el-date-picker
            v-model="form.入职日期"
            size="mini"
            placeholder="入职日期"
            value-format="yyyy-MM-dd"
            style="width:350px"
          ></el-date-picker>
        </div>
      </div>
      <div style="font-size:16px;font-weight:bold;margin: 10px 0 3px 0">支付明细：</div>
      <div v-if="!isFinance" class="paydoc-dia-form-item">
        <el-input v-model="form.支付明细" size="mini" placeholder="支付明细"></el-input>
      </div>
      <div class="paydoc-dia-form-item">
        <label style="width:105px">应收取服务费：</label> <span style="color:#666">人民币 </span>
        <el-input v-model="form.服务费" size="mini" placeholder="服务费" style="width:270px"></el-input>
      </div>
      <div class="paydoc-dia-form-item" style="color:#666">请您尽快以支票或银行电汇的形式支付上述款项。</div>
      <div class="paydoc-dia-form-item" style="margin-top:10px">
        <label style="width:80px;font-size:16px;font-weight:bold;">账户资料：</label>
        <span class="text-12 text-warn">（需要注意签约主体）</span>
      </div>
      <div class="paydoc-dia-form-item">
        <label style="width:70px">公司名称：</label>
        <el-input v-model="form.公司名称" size="mini" style="width:350px"></el-input>
      </div>
      <div class="paydoc-dia-form-item">
        <label style="width:70px">银行名称：</label>
        <el-input v-model="form.银行名称" size="mini" style="width:350px"></el-input>
      </div>
      <div class="paydoc-dia-form-item">
        <label style="width:70px">银行账号：</label>
        <el-input v-model="form.银行账号" size="mini" style="width:350px"></el-input>
      </div>
      <div class="paydoc-dia-form-item" style="text-align:right">{{ form.公司名称 }}</div>
    </div>
    <!-- <el-button
      v-if="tmpType == 'normal' || isFinance"
      type="primary"
      size="mini"
      @click="confirm"
      style="position:absolute;bottom:10px;right:20px"
    >
      制作完成
    </el-button> -->
    <!-- 搜索人选弹窗 -->
    <serchRadishDialog
      ref="serchRadishDialog"
      :could-insert="true"
      choose-btn-text="添加"
      :could-choose-more="true"
      @choose="chooseRadish"
      @chooseMore="chooseMoreRadish"
    ></serchRadishDialog>
    <el-dialog
      title="点击下载付款通知书"
      :append-to-body="true"
      :close-on-click-modal="false"
      :modal="false"
      :visible.sync="filesVisible"
    >
      <div v-for="(file, k) in files" :key="k" style="padding-bottom:10px">
        <span class="a-link" @click="download(file)">{{ file.originalname }}</span>
      </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
import serchRadishDialog from '../../../company/src/component/serchRadishDialog'
import { download } from '../../../project/src/constant/utils'

const toThousands = num => (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
const digitUppercase = function(n) {
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']]
  const head = n < 0 ? '欠' : ''
  n = Math.abs(n)
  let s = ''
  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)
  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = ''
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(n / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
  )
}
export default {
  components: { serchRadishDialog },
  data() {
    return {
      dialogVisible: false,
      banks: [
        {
          账户名称: '浙江阿尔法人力资源有限公司',
          开户行: '招商银行股份有限公司湖州德清支行',
          账号: '572900225610716',
        },
        {
          账户名称: '浙江微元智能科技股份有限公司',
          开户行: '中国建设银行股份有限公司德清支行营业部',
          账号: '33050164732700001016',
        },
        {
          账户名称: '北京阿尔法智人科技有限公司',
          开户行: '招商银行股份有限公司北京分行东三环支行',
          账号: '110926454310902',
        },
        {
          账户名称: '佛山市智招科技有限公司',
          开户行: '中国工商银行股份有限公司佛山南海丹灶支行',
          账号: '2013024409200081960',
        },
        {
          账户名称: '山东阿尔法猎人科技有限公司',
          开户行: '招商银行股份有限公司潍坊寿光支行',
          账号: '536903795610705',
        },
      ],
      rid: '',
      pid: '',
      tmpType: 'normal',
      isFinance: false,
      bank: '浙江阿尔法人力资源有限公司',
      form: {},
      towork: {},
      loading: false,
      companyHrs: [],
      company: {},
      project: {},
      isHrShow: false,
      money: 0,
      files: [],
      filesVisible: false,
      paydocId: '',
      docOrder: '',
      times: '',
    }
  },
  computed: {
    download() {
      return download
    },
  },
  methods: {
    async open({ rid, pid, bank, tmpType, times }) {
      if (!rid) return console.error('缺少rid')
      if (!pid) return console.error('缺少pid')
      this.rid = rid
      this.pid = pid
      this.times = times
      if (bank) this.bank = bank
      if (tmpType) this.tmpType = tmpType
      const form = {
        客户公司名称: '',
        客户公司地址: '',
        付款通知书编号: '',
        合同编号: '',
        对接HR: '',
        电话: '',
        岗位名称: '',
        候选人姓名: '',
        支付明细: '',
        服务费: '',
        服务费数字: '', // 字符
        公司名称: '',
        银行名称: '',
        银行账号: '',
        部门: '',
        级别: '',
        职位: '',
        邮箱: '',
        工作地点: '',
        入职日期: '',
        工作日: '',
        本期百分比: '',
        本期支付费用: '',
        入职期: '',
        试用期: '6',
      }
      // 获取项目
      const project = await app.service('project').fetch(this.pid)
      if (!project) {
        this.$message.warning('项目不存在')
        return false
      }
      form.岗位名称 = project.项目名称
      form.部门 = project.部门 || ''
      form.工作地点 = project.办公地 && project.办公地.length > 0 ? project.办公地.join(',') : ''
      this.project = project
      // 获取公司
      const resCom = await app.service('company').getCompany(project.客户公司)
      if (resCom.status === 200) {
        form.客户公司名称 = resCom.result.公司名称
        this.company = resCom.result
        const resHr = await app.service('company').getCompanyHr(resCom.result.对接hr || [])
        if (resHr.status === 'success') this.companyHrs = resHr.data
        if (resCom.result.附件 && resCom.result.附件.length > 0) {
          const attachs = resCom.result.附件
            .filter(a => a.type == '合同')
            .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
          if (attachs.length > 0) {
            const xiang = attachs[0].合同详情
            if (xiang) {
              form.合同编号 = xiang.合同编号 || ''
              form.客户公司地址 = xiang.邮件寄送地址 || ''
            }
          }
        }
      }
      this.form = form
      // 开票信息
      if (bank) {
        await this.changeBank(bank)
      }
      // 获取到岗信息
      const resTowork = await app.service('radish').findTowork({ rid: this.rid, pid: this.pid })
      if (resTowork.status === 'success' && resTowork.data.length > 0) {
        const towork = resTowork.data[0]
        this.towork = towork
        // 计算费用
        await this.changeTmp()
      }
      this.dialogVisible = true
    },
    async changeTmp() {
      const form = {}
      const towork = this.towork
      form.候选人姓名 = towork.候选人
      form.职位 = towork.职位
      const money = (towork.佣金额 || 0) * 1000 * 10
      const moneyThou = toThousands(money)
      if (towork.合同比例 == '固定收费' || towork.合同比例 == '最低收费') {
        if (towork.开票批次 == '二次付款') {
          const bili = this.times == 'second' ? towork.第二期比例 : towork.第一期比例
          const biliMoney = (money * bili) / 100
          this.money = biliMoney
          if (this.tmpType == 'normal') {
            form.支付明细 = `= RMB${moneyThou}(${towork.合同比例}) *${bili}%`
            form.服务费 = `${toThousands(money)}`
            form.本期百分比 = this.times == 'second' ? towork.第二期比例 : towork.第一期比例
            form.本期支付费用 = `${toThousands(biliMoney)}`
            form.入职期 = towork.试用期
          } else {
            form.支付明细 = moneyThou
            form.服务费 = `${digitUppercase(biliMoney)}(${toThousands(biliMoney)})`
          }
          form.试用期 = '6'
          form.服务费数字 = toThousands(biliMoney)
        } else {
          this.money = money
          if (this.tmpType == 'normal') {
            form.支付明细 = `= RMB${moneyThou}(${towork.合同比例})`
            form.服务费 = `${moneyThou}`
          } else {
            form.支付明细 = moneyThou
            form.服务费 = `${digitUppercase(money)}(${moneyThou})`
          }
          form.服务费数字 = moneyThou
        }
      } else if (towork.开票批次 == '二次付款') {
        const bili = this.times == 'second' ? towork.第二期比例 : towork.第一期比例
        const biliMoney = (money * bili) / 100
        this.money = biliMoney
        if (this.tmpType == 'normal') {
          form.支付明细 = `= RMB${toThousands((towork.固定年薪 || 0) * 1000 * 10)}(税前固定年薪) *${
            towork.合同比例
          }% *${bili}%`
          form.服务费 = `${toThousands(money)}`
          form.本期百分比 = this.times == 'second' ? towork.第二期比例 : towork.第一期比例
          form.本期支付费用 = `${toThousands(biliMoney)}`
          form.入职期 = towork.试用期
        } else {
          form.支付明细 = `${toThousands((towork.固定年薪 || 0) * 1000 * 10)}*${
            towork.合同比例
          }%*${bili}%=${toThousands(biliMoney)}`
          form.服务费 = `${digitUppercase(biliMoney)}(${toThousands(biliMoney)})`
        }
        form.试用期 = '6'
        form.服务费数字 = toThousands(biliMoney)
      } else {
        this.money = money
        if (this.tmpType == 'normal') {
          form.支付明细 = `= RMB${toThousands((towork.固定年薪 || 0) * 1000 * 10)}(税前固定年薪) *${towork.合同比例}%`
          form.服务费 = `${moneyThou}`
        } else {
          form.支付明细 = `${toThousands((towork.固定年薪 || 0) * 1000 * 10)}*${towork.合同比例}%=${moneyThou}`
          form.服务费 = `${digitUppercase(money)}(${moneyThou})`
        }
        form.服务费数字 = moneyThou
      }
      const res = await app.service('project').getPaydocContent({
        pid: this.pid,
        rid: this.rid,
        tmpType: this.tmpType,
        times: this.times,
      })
      // console.log('paydoc', res)
      if (res.status == 'success') {
        if (res.data) {
          this.paydocId = res.data._id
          this.docOrder = res.data.docOrder
          const content = res.data.content || {}
          const fee = form.服务费
          const curFee = form.本期支付费用
          const curPercent = form.本期百分比
          const tryPeriod = form.入职期
          Object.assign(form, res.data.content)
          // 替换为新模板时，此项内容会被旧内容覆盖，需要恢复
          if (this.tmpType == 'normal') {
            form.服务费 = fee
            form.本期支付费用 = curFee
            form.本期百分比 = curPercent
            form.入职期 = tryPeriod
          }
          form.试用期 = '6'
        } else {
          const resLast = await app.service('project').getPaydocContent({
            year: new Date().getFullYear(),
          })
          if (resLast.status == 'success' && resLast.data) {
            this.docOrder = `00${parseInt(resLast.data.docOrder) + 1}`.slice(-3)
          } else {
            this.docOrder = '001'
          }
          form.付款通知书编号 = `INV${this.project.编号}.${this.docOrder}`
        }
      }
      // console.log('form', form)
      Object.assign(this.form, form)
      this.isFinance = false
    },
    changeBank(val) {
      const form = {}
      const bankObj = this.banks.find(b => b.账户名称 == val)
      if (bankObj) {
        form.公司名称 = bankObj.账户名称
        form.银行名称 = bankObj.开户行
        form.银行账号 = bankObj.账号
      }
      Object.assign(this.form, form)
    },
    showHrs() {
      if (this.company._id) this.isHrShow = true
    },
    chooseHr(hr) {
      Object.assign(this.form, { 对接HR: hr.姓名, 电话: hr.手机, 邮箱: hr.邮箱 })
      this.isHrShow = false
    },
    async defaultSerchRadish() {
      let defaultSearchRadishes = []
      const res = await app.service('company').defaultSearchHrs(this.company.简称)
      if (res.status == 'success') {
        defaultSearchRadishes = res.data
      } else {
        this.$message.error(res.msg)
      }
      this.isHrShow = false
      this.$refs.serchRadishDialog.open({ 公司: this.company.简称 }, defaultSearchRadishes)
    },
    chooseMoreRadish(radishes) {
      for (const radish of radishes) {
        this.chooseRadish(radish)
      }
    },
    chooseRadish(radish) {
      const result = this.companyHrs.find(leader => leader.rid === radish._id)
      if (result) return this.$message.warning('该人选已添加，请勿重复操作')
      this.addCompanyLeader(radish)
    },
    async addCompanyLeader(radish) {
      const leader = {
        rid: radish._id,
        cid: this.company._id,
        姓名: radish.姓名,
        目前职位: radish.目前职位,
        职级: radish.职级,
        手机: radish.手机,
        座机: radish.座机,
        邮箱: radish.邮箱,
      }
      try {
        const res = await app.service('company').addCompanyHr(leader)
        if (res.status === 'success') {
          const hr = Object.assign(
            {
              _id: res.data._id,
            },
            leader,
          )
          this.companyHrs.push(hr)
          this.chooseHr(hr)
          this.$message.success(`操作成功`)
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error(e)
      }
    },
    async confirm() {
      if (this.loading) return this.$message('正在处理请稍候')
      if (!this.form.对接HR) return this.$message(`请选择${this.tmpType == 'normal' ? '收件人' : '联系人'}`)
      this.loading = true
      // 保存主体等数据
      const res = await app.service('radish').updateTowork({
        rid: this.rid,
        pid: this.pid,
        data: {
          开票主体: this.form.公司名称,
          客户公司: this.form.客户公司名称,
          开票金额: this.money,
        },
        type: 'edit',
      })
      const qi = this.times == 'second' ? '(第二期)' : this.towork.开票批次 == '二次付款' ? '(第一期)' : ''
      const files = []
      if (this.tmpType == 'normal') {
        const res = await app.service('file').generatePayment({
          form: this.form,
          fileName: `阿尔法-付款通知书-${this.form.候选人姓名}${qi}.docx`,
          tmpType: 'normal',
          times: this.times,
        })
        if (res.status == 'success') {
          await app.service('project').upsertPayAttachment(
            Object.assign(res.data, {
              type: '付款通知书',
              projectId: this.pid,
              rid: this.rid,
              tmpType: 'normal',
              times: this.times,
            }),
          )
          const content = {
            pid: this.pid,
            rid: this.rid,
            tmpType: this.tmpType,
            times: this.times,
            year: new Date().getFullYear(),
            docOrder: this.docOrder,
            content: this.form,
          }
          await app.service('project').setPaydocContent(content)
          this.loading = false
          this.$message.success('制作成功')
          this.modifyStatus()
          download(res.data)
          app.root.$refs.makePayDoc.close()
          this.dialogVisible = false
        } else {
          this.$message.error(res.msg)
          this.loading = false
        }
      } else {
        const res1 = await app.service('file').generatePayment({
          form: this.form,
          fileName: `Debit note-detail for HR record-${this.form.候选人姓名}${qi}.docx`,
          tmpType: 'detail',
        })
        if (res1.status == 'success') {
          await app.service('project').upsertPayAttachment(
            Object.assign(res1.data, {
              type: '付款通知书',
              projectId: this.pid,
              rid: this.rid,
              tmpType: 'detail',
              times: this.times,
              content: this.form,
            }),
          )
          const content = {
            pid: this.pid,
            rid: this.rid,
            tmpType: this.tmpType,
            times: this.times,
            year: new Date().getFullYear(),
            docOrder: this.docOrder,
            content: this.form,
          }
          await app.service('project').setPaydocContent(content)
          this.loading = false
          this.$message.success('HR版制作成功')
          this.modifyStatus()
          files.push(res1.data)
          app.root.$refs.makePayDoc.close()
          this.dialogVisible = false
        } else {
          this.$message.error(res1.msg)
          this.loading = false
        }
        const res2 = await app.service('file').generatePayment({
          form: this.form,
          fileName: `Debit note-detail for Finance record-${this.form.候选人姓名}${qi}.docx`,
          tmpType: 'finance',
        })
        if (res2.status == 'success') {
          await app.service('project').upsertPayAttachment(
            Object.assign(res2.data, {
              type: '付款通知书',
              projectId: this.pid,
              rid: this.rid,
              tmpType: 'finance',
              times: this.times,
              content: this.form,
            }),
          )
          this.loading = false
          this.$message.success('财务版制作成功')
          files.push(res2.data)
          app.root.$refs.makePayDoc.close()
          this.dialogVisible = false
        } else {
          this.loading = false
          this.$message.error(res2.msg)
        }
        this.files = files
        this.filesVisible = true
      }
    },
    async modifyStatus() {
      await app.service('radish').modifyStatus({
        rid: this.rid,
        pid: this.pid,
        status: { tag: this.times == 'second' ? '过保' : '到岗', detail: '未开票' },
      })
    },
  },
}
</script>
<style>
.paydoc-dia-form-item {
  padding: 3px 0;
  color: #000;
}
.paydoc-dia-form-item label {
  display: inline-block;
}
.paydoc-dia-form-item.paydoc-require .el-input input {
  border: 1px solid #f60;
}
</style>
